import { MAX_FOLDER_PANE_WIDTH } from '../internalConstants';
import { MAX_LIST_VIEW_WIDTH } from '../mailLayoutConstants';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';
import { getStore } from '../store/Store';

/**
 * Gets the left nav max width for the current browser window width
 */
export function getLeftNavMaxWidth(): number {
    const browserWidthBucket = getStore().browserWidthBucket;
    switch (browserWidthBucket) {
        case BrowserWidthBucket.From418_Below:
        case BrowserWidthBucket.From419_To554:
        case BrowserWidthBucket.From555_To768:
        case BrowserWidthBucket.From769_To918:
        case BrowserWidthBucket.From919_To999:
            return 198;
        case BrowserWidthBucket.From1000_To1199:
            return 236;
        case BrowserWidthBucket.From1200_To1399:
            return 254;
        case BrowserWidthBucket.From1400_To1599:
            return 300;
        case BrowserWidthBucket.From1600_Above:
            return 320;
        default:
            return MAX_FOLDER_PANE_WIDTH;
    }
}

/**
 * Gets the list view max width for the current browser window width
 */
export function getListViewMaxWidth(): number {
    const browserWidthBucket = getStore().browserWidthBucket;
    switch (browserWidthBucket) {
        case BrowserWidthBucket.From418_Below:
        case BrowserWidthBucket.From419_To554:
        case BrowserWidthBucket.From555_To768:
        case BrowserWidthBucket.From769_To918:
        case BrowserWidthBucket.From919_To999:
            return 350;
        case BrowserWidthBucket.From1000_To1199:
            return 380;
        case BrowserWidthBucket.From1200_To1399:
            return 452;
        case BrowserWidthBucket.From1400_To1599:
            return 540;
        case BrowserWidthBucket.From1600_Above:
            return 574;
        default:
            return MAX_LIST_VIEW_WIDTH;
    }
}
